import { LocalNote } from './local-note.model';
import { LocalLoadNotification } from './local-load-notification.model';

export class LocalLoadCommunication {

  public notes: LocalNote[]                     = [];
  public notifications: LocalLoadNotification[] = [];

  static fromDto(data: any): LocalLoadCommunication {
    if (!data) {
      return null;
    }

    const communication = new LocalLoadCommunication();

    if (data.notes) {
      communication.notes = data.notes.map(n => LocalNote.fromDto(n));
    }

    if (data.notifications) {
      communication.notifications = data.notifications.map(n => LocalLoadNotification.fromDto(n));
    }

    return communication;
  }

  sortNotes() {
    this.notes.sort((a, b) => a.createdAt.utc().diff(b.createdAt.utc()));
  }
}
